import PropTypes from "prop-types";
import React from "react";

const { number } = PropTypes;

const ReviewStars = ({ totalStars }) => {
  if (typeof totalStars === "undefined") return null;
  return (
    <span>
      {new Array(4).fill(1).map((item, itemIndex) => {
        return itemIndex < totalStars ? (
          <i
            className="varsome-icons icon-star"
            style={{ color: "grey" }}
            key={itemIndex}
          />
        ) : (
          <i
            className="varsome-icons icon-star-o"
            style={{ color: "grey" }}
            key={itemIndex}
          />
        );
      })}
    </span>
  );
};

ReviewStars.propTypes = {
  totalStars: number,
};
ReviewStars.defaultProps = {
  totalStars: 0,
};
export default ReviewStars;
